/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/dialogs/tryadd-art-to-wk-confirm/shop.dialogs.tryadd-art-to-wk-confirm.component.ts.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TryAddArtikelToWkResponse} from '../../models/try-add-artikel-to-wk-response';
import {Artikel} from '../../../../models/artikel';

/**
 * Zweck: Beschreibt class ShopDialogsTryaddArtToWkConfirmComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    templateUrl: 'shop.dialogs.tryadd-art-to-wk-confirm.component.html',
    styleUrls: ['shop.dialogs.tryadd-art-to-wk-confirm.component.scss'],
    standalone: false
})
export class ShopDialogsTryaddArtToWkConfirmComponent implements OnInit {

  raiseAmount = 0;
  setAmount = 0;
  currentAmount = 0;
  amountAfterAdd = 0;
  currentWkEntries: {position: number, amount: number, isTarget: boolean}[] = [];
  targetPositionNumber: number = null;
  targetPositionAmount = 0;
  targetPositionAmountAfterAdd = 0;

  title = '';
  subtitle = '';
  text: string;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public dialogRef: MatDialogRef<ShopDialogsTryaddArtToWkConfirmComponent>,
              @Inject(MAT_DIALOG_DATA) public data: {
                artikel: Artikel,
                state: TryAddArtikelToWkResponse,
                amount: number
              }) {

  }

/**
 * Beschreibt Methode render und ihren Rückgabevertrag.
 */
  render() {
    this.title = this.data.artikel.label;
    if (this.data.state.inOrdersAmount > 0) {
      this.subtitle = 'Bereits bestellt!';
      this.text = 'Es wurde' + (this.data.state.inOrdersAmount > 1 ? 'n' : '') + ' heute bereits <span style="font-weight: bold">' + this.data.state.inOrdersAmount + ' Stück</span> bestellt!';

    } else if (this.data.state.inOtherWkAmount > 0) {
      this.subtitle = 'Bereits in einem Warenkorb!';
      this.text = 'Es befinde' + (this.data.state.inOtherWkAmount > 1 ? 'n' : 't') + ' sich bereits <span style="font-weight: bold">' + this.data.state.inOtherWkAmount + ' Stück</span> in einem anderen Warenkorb!';

    } else if (this.data.state.inCurrentWkAmount > 0) {
      this.subtitle = 'Bereits im Warenkorb!';
      this.text = '<span style="font-weight: bold">' + this.data.state.inCurrentWkAmount + ' Stück</span> ' + (this.data.state.inCurrentWkAmount > 1 ? 'sind' : 'ist') + ' bereits im Warenkorb!';

    } else if (this.data.state.inResidues > 0) {
      this.subtitle = 'Bereits im Rückstand!';
      this.text = '<span style="font-weight: bold">' + this.data.state.inResidues + ' Stück</span> ' + (this.data.state.inResidues > 1 ? 'sind' : 'ist') + ' bereits im Rückstand!';
    }
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.currentAmount = Number(this.data.state.inCurrentWkAmount) || 0;
    const amount = Number(this.data.amount) || 0;
    this.amountAfterAdd = this.currentAmount + amount;
    this.currentWkEntries = this.data.state.inCurrentWkEntries || [];
    const targetPosition = this.currentWkEntries.find(position => position.isTarget);
    if (targetPosition) {
      this.targetPositionNumber = targetPosition.position;
      this.targetPositionAmount = Number(targetPosition.amount) || 0;
      this.targetPositionAmountAfterAdd = this.targetPositionAmount + amount;
    }

    this.raiseAmount = this.amountAfterAdd;
    this.setAmount = this.data.amount;
    this.render();
  }

/**
 * Beschreibt Methode setResponse und ihren Rückgabevertrag.
 */
  setResponse(state, amount: number) {
    this.dialogRef.close({
      state: state,
      amount: amount,
      setAmount: this.setAmount,
      raiseAmount: this.raiseAmount,
    });
  }
}
